module.exports = __webpack_public_path__ + "static/media/poktshape.9e23bfbb.png";